import * as types from './types';
import { Project } from '@interfaces/outreach-entity';
import ListResponse from '@interfaces/list-response';
import { YearsFilter } from '@interfaces/years-filter';
import { RequestState } from '@interfaces/request-state';
import { OutreachRequestParams } from '@interfaces/outreach-request-params';

export interface ProjectsPageState extends RequestState {
    readonly list: ListResponse<Project>;
    readonly listParams: OutreachRequestParams;
    readonly filters: YearsFilter & RequestState;
}

const initialState: ProjectsPageState = {
    list: {
        rows: [],
        meta: {}
    },
    listParams: {},
    filters: {
        years: [],
        isLoading: false,
        error: undefined
    },
    isLoading: false,
    error: undefined
};

/* tslint:disable-next-line cyclomatic-complexity */
function reducer(state = initialState, action: any): ProjectsPageState {
    switch (action.type) {
        case types.FETCH_PROJECTS_PAGE:
            return fetchProjects(state, action);

        case types.FETCH_PROJECTS_PAGE_SUCCESS:
            return fetchProjectsSuccess(state, action);

        case types.FETCH_PROJECTS_PAGE_ERROR:
            return fetchProjectsError(state, action);

        case types.FETCH_PROJECTS_FILTERS:
            return fetchProjectsFilters(state);

        case types.FETCH_PROJECTS_FILTERS_SUCCESS:
            return fetchProjectsFiltersSuccess(state, action);

        case types.FETCH_PROJECTS_FILTERS_ERROR:
            return fetchProjectsFiltersError(state, action);

        default:
            return state;
    }
}

function fetchProjects(state: ProjectsPageState, action: any) {
    const { page = 1 } = action.payload || {};

    const list = {
        ...state.list,
        rows: page === 1 ? [] : state.list.rows
    };

    return {
        ...state,
        list,
        isLoading: true,
        error: undefined
    };
}

function fetchProjectsSuccess(state: ProjectsPageState, action: any) {
    const { data, params } = action.payload;
    const { meta, rows: actionRows } = data;
    const rows = meta.pageNumber === 1 ? actionRows : [...state.list.rows, ...actionRows];

    return {
        ...state,
        list: { meta, rows },
        listParams: params,
        isLoading: false,
        error: undefined
    };
}

function fetchProjectsError(state: ProjectsPageState, action: any) {
    return {
        ...state,
        isLoading: false,
        error: action.payload
    };
}

function fetchProjectsFilters(state: ProjectsPageState) {
    return {
        ...state,
        filters: {
            ...state.filters,
            isLoading: true,
            error: undefined
        }
    };
}

function fetchProjectsFiltersSuccess(state: ProjectsPageState, action: any) {
    const { years } = action.payload;

    return {
        ...state,
        filters: {
            ...state.filters,
            isLoading: false,
            years
        }
    };
}

function fetchProjectsFiltersError(state: ProjectsPageState, action: any) {
    return {
        ...state,
        filters: {
            ...state.filters,
            isLoading: false,
            error: action.payload
        }
    };
}

export default reducer;
